import { fn } from 'storybook/test';
import { Fragment } from 'react/jsx-runtime';

import type { Meta, StoryFn } from '@storybook/react';
import type { SortableProps } from './Sortable';

import { Sortable } from './Sortable';

import { InputField } from 'components/InputField';
import { Icon } from 'components/Icon';
import { Button } from 'components/Buttons';

const codeString = `<Sortable onSort={onSortFunction} ItemHandlePlacement={ItemHandlePlacement} scrollable={scrollable} 
    disabled={ disabled } hideNumbers={ hideNumbers } sortableItemColor={ sortableItemColor } > { children } </ Sortable > `;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Organisms/Sortable',
  component: Sortable,
  argTypes: {
    children: {
      table: {
        disable: true,
      },
    },
    ItemHandlePlacement: {
      table: {
        disable: true,
      },
    },
  },
  parameters: {
    inspectComponent: Sortable,
    codeString: codeString,
  },
} as Meta<SortableProps>;

const defaultArgs: Partial<SortableProps> = {
  ItemHandlePlacement: 'left',
  onSort: fn(),
};

const mockItems = ['Item-1', 'Item-2', 'Item-3', 'Item-4', 'Item-5'];

const Template: StoryFn<SortableProps> = (args) => <Sortable {...args}>{mockItems}</Sortable>;

export const SortableExample = Template.bind({});
SortableExample.args = {
  ...defaultArgs,
};

export const withHandleRight = Template.bind({});
withHandleRight.args = {
  ...defaultArgs,
  ItemHandlePlacement: 'right',
};

const TemplateComplex: StoryFn<SortableProps> = (args) => (
  <Sortable {...args}>
    {mockItems.map((item) => (
      <Fragment key={item}>
        <div style={{ width: '100%' }}>
          <InputField key={item} id={item} placeholder={item} />
        </div>
        <Button variant="blank-icon">
          <Icon name="Trash" color="#a0002aff" />
        </Button>
      </Fragment>
    ))}
  </Sortable>
);

export const WithComplexChildren = TemplateComplex.bind({});
WithComplexChildren.args = {
  ...defaultArgs,
  childrenData: [
    { title: 'item-1', value: 1 },
    { title: 'item-2', value: 2 },
    { title: 'item-3', value: 3 },
    { title: 'item-4', value: 4 },
    { title: 'item-5', value: 5 },
  ],
};
